module.exports = __webpack_public_path__ + "static/media/logo-evohome.9118051d.svg";